// extracted by mini-css-extract-plugin
export default {"container":"CommonToastPopup_container__jqJRy","text":"CommonToastPopup_text__Z++rF"};